import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, TextField } from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";

import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import Required from "../../../../utility/required";
import { useShallow } from "zustand/react/shallow";
import { maxButtonTextForList } from "../../../channels/global/whatsapp/templates/utils";
import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import { isTemplateCreated } from "../../constant";

function WhatsAppTemplateFormButtonTextforListType() {

    const { createTemplatePayload, setCreateTemplatePayload } = useTemplateLibraryStore(useShallow((state) => ({
        createTemplatePayload: state.createTemplatePayload,
        setCreateTemplatePayload: state.setCreateTemplatePayload,
    })));

    return (
        <>
            <Accordion defaultExpanded={true} className={`${styles.accordion}`}>
                
                <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className={styles.accordion__summary}>

                    <Grid container justifyContent={"space-between"} alignItems={"center"}>
                        <span className={styles.accordion__summary__text}>
                            Button Text <Required />
                        </span>

                        <span className={styles.accordion__summary__value}>
                            {`${createTemplatePayload?.interactive_list_button_text?.length ?? 0}/${maxButtonTextForList}`}
                        </span>
                    </Grid>

                </AccordionSummary>

                <Divider sx={{ width: "100%", opacity: "1" }} />

                <AccordionDetails className={styles.accordion__details}>
                    
                    <Grid container>
                        <TextField
                            disabled={isTemplateCreated(createTemplatePayload)}
                            variant="outlined"
                            value={createTemplatePayload?.interactive_list_button_text ?? ""}
                            size='small'
                            className={styles.templateGlobalTextfield}
                            fullWidth
                            onChange={(event: any) => {
                                if(event.target.value.length <= maxButtonTextForList){
                                    setCreateTemplatePayload({
                                        ...createTemplatePayload,
                                        interactive_list_button_text: event.target.value,
                                    })
                                }
                            }}
                            inputProps={{ dir: 'auto' }}
                            sx={{
                                '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none'
                                },
                                margin: '10px 0px'
                            }}
                            autoComplete='off'
                            placeholder='Enter button text here'
                            FormHelperTextProps={{
                                style: {
                                    textAlign: 'right',
                                    fontSize: '14px',
                                    fontWeight: '600'
                                }
                            }}
                        />
                    </Grid>

                </AccordionDetails>
            </Accordion>

        </>
    );
}

export default WhatsAppTemplateFormButtonTextforListType;